import React from 'react';
import get from 'lodash/get';
import { NumberField } from 'react-admin';


/**
 * Like <NumberField> except this parses the value. Default paraser is
 * Number.parseFloat and can overrwide using the `parse` property.
 */
function ParsedNumberField({
  parse = Number.parseFloat,
  record,
  source,
  ...rest
}) {
  return (
    <NumberField
      record={{
        ...record,
        [source]: parse(get(record, source)),
      }}
      source={source}
      {...rest}
    />
  );
}

ParsedNumberField.defaultProps = {
  textAlign: 'right',
};

export default ParsedNumberField;



// WEBPACK FOOTER //
// ./src/components/ParsedNumberField.js